import { getMFELocationOverrides } from '../devTools';
import { LEGACY_MFES, LEGACY_MODULE_MFES, MFE_LOCATIONS } from './constants';
import type { TLoadMFE, TMFEName, TMFELocationOverrides } from './types';

export const loadMFE: TLoadMFE = (mfeName, onLoad, asModule) => {
    const mfeLocationOverrides = getMFELocationOverrides();
    const scriptSrc = getBootstrapScriptUrl(mfeName, mfeLocationOverrides);
    const existingScriptTag = document.querySelector(`script[src="${scriptSrc}"]`);
    if (!existingScriptTag && !customElements.get(mfeName)) {
        const script = document.createElement('script');
        if (asModule) {
            script.type = 'module';

            const style = document.createElement('link');
            style.rel = 'stylesheet';
            style.href = getBootstrapStylesUrl(mfeName, mfeLocationOverrides);
            document.head.appendChild(style);
        }
        if (onLoad) {
            script.onload = onLoad;
        }
        script.src = scriptSrc;
        document.head.appendChild(script);
    } else {
        if (onLoad) {
            onLoad();
        }
    }
};

export const getMFELocation = (mfe: TMFEName, mfeLocationOverrides: TMFELocationOverrides) => {
    if (mfeLocationOverrides && mfeLocationOverrides[mfe]) {
        return mfeLocationOverrides[mfe];
    }
    return MFE_LOCATIONS[mfe] || MFE_LOCATIONS.DEFAULT;
};

export const getBlockManifest = (mfe: TMFEName, mfeLocationOverrides: TMFELocationOverrides) => {
    const mfeLocation = getMFELocation(mfe, mfeLocationOverrides);

    return `${mfeLocation}/manifest/ssr`;
};
export const getBootstrapScriptUrl = (
    mfe: TMFEName,
    mfeLocationOverrides: TMFELocationOverrides
) => {
    const mfeLocation = getMFELocation(mfe, mfeLocationOverrides);

    if (LEGACY_MFES.includes(mfe) || LEGACY_MODULE_MFES.includes(mfe)) {
        return `${mfeLocation}/index.js`;
    }

    return `${mfeLocation}/bootstrap/script.js`;
};
export const getBootstrapStylesUrl = (
    mfe: TMFEName,
    mfeLocationOverrides: TMFELocationOverrides
) => {
    const mfeLocation = getMFELocation(mfe, mfeLocationOverrides);

    if (LEGACY_MODULE_MFES.includes(mfe)) {
        return `${mfeLocation}/index.css`;
    }

    if (LEGACY_MFES.includes(mfe)) {
        return '';
    }

    return `${mfeLocation}/assets/index.css`;
};

export const safeStringify = (obj: unknown): string => {
    try {
        return JSON.stringify(obj);
    } catch (e) {
        console.error(e);
        return '';
    }
};

export const encodeParams = (params: Record<string, unknown>) => {
    return btoa(encodeURIComponent(safeStringify(params)));
};
